import { FC, ReactNode } from 'react';
import { Box } from '@mui/material';
import { colors, radii, shadows } from '../../theme/tokens';
import ListState, { ListStateProps, hasListState } from '../ListState';

// The table on mobile (ROADMAP.md, Part 2, "Tables → cards"): stacked
// cards. Each listing paints the content of its cards with `ListCard`;
// here go the list, its states (loading, error, empty) and each card's box,
// so that documents and users look the same.

type ListCardsProps = ListStateProps & {
  ariaLabel: string;
  children: ReactNode;
};

export const ListCards: FC<ListCardsProps> = ({
  ariaLabel,
  children,
  ...state
}) => {
  if (hasListState(state)) {
    return <ListState {...state} />;
  }

  return (
    <Box
      component="ul"
      aria-label={ariaLabel}
      sx={{ listStyle: 'none', m: 0, p: 0, display: 'grid', gap: 1.5 }}
    >
      {children}
    </Box>
  );
};

export const ListCard: FC<{ children: ReactNode }> = ({ children }) => (
  <Box
    component="li"
    sx={{
      backgroundColor: colors.white,
      border: `1px solid ${colors.border}`,
      borderRadius: `${radii.card}px`,
      boxShadow: shadows.card,
      p: 2,
      display: 'flex',
      flexDirection: 'column',
      gap: 1,
    }}
  >
    {children}
  </Box>
);

// Labelled datum inside a card ("EMISSION / 10/02/2026").
export const ListCardField: FC<{ label: string; children: ReactNode }> = ({
  label,
  children,
}) => (
  <Box>
    <Box
      component="span"
      sx={{
        display: 'block',
        fontSize: '0.6875rem',
        textTransform: 'uppercase',
        color: colors.muted,
        letterSpacing: 0,
      }}
    >
      {label}
    </Box>
    <Box component="span" sx={{ fontSize: '0.875rem' }}>
      {children}
    </Box>
  </Box>
);

export default ListCards;
